export class ItemPickerOptionModel {
	public isSelected: boolean;
	public displayName: string;
	public value: string;

	public constructor(params: Partial<ItemPickerOptionModel>) {
		this.isSelected = params.isSelected ?? false;
		this.displayName = params.displayName;
		this.value = params.value;
	}
}
